export default "__VITE_ASSET__BktFq1Yf__"